export type Host = "web" | "crazygames";

const host: Host = typeof document !== "undefined"
    && document.documentElement.dataset.host === "web"
    ? "web"
    : "crazygames";

const HostConfig = {
    host,
    features: {
        authentication: true,
        recovery: host === "web",
    },
} as const;

export default HostConfig;
